// storeApiRouter.js 對應後端 BackStoreApiRouter
import service from './service'

export default {
	// 系統參數
	platformParam: {
		get: paramId => service.get(`back/store/platformParam/${paramId}`),
	},
	// 公告
	announcement: {
		getAnnouncementDisplayList: params =>
			service.post(`/back/store/announcement/recentList`, params),
	},
	// 報表>營業額
	orderReport: {
		getOrderPage: params =>
			service.post(`/back/store/report/order/page`, params),
		calculateTotalRevenue: params =>
			service.post(`/back/store/report/order/revenue`, params),
		printCheck: params =>
			service.get(`/back/store/report/order/printCheck`, { params }),
		printOrder: params =>
			service.post(`/back/store/report/order/print`, params),
		batchRemoveOrder: params =>
			service.delete(`/back/store/report/order/batchRemove`, { params }),
		getAvailablePayMethods: params =>
			service.post(`/back/store/report/order/payMethods`, params),
	},
	// 報表>收支
	cashDrawerRecord: {
		add: params =>
			service.post(`/back/store/report/cashDrawerRecord/add`, params),
		update: params =>
			service.put(`/back/store/report/cashDrawerRecord/update`, params),
		batchRemove: params =>
			service.delete(`/back/store/report/cashDrawerRecord/batchRemove`, {
				params,
			}),
		getPage: params =>
			service.post(`/back/store/report/cashDrawerRecord/page`, params),
		summary: params =>
			service.post(`/back/store/report/cashDrawerRecord/summary`, params),
	},
	// 報表>交班
	shiftReport: {
		getShiftPage: params =>
			service.post(`/back/store/report/shift/page`, params),
		finishShift: params =>
			service.post(`/back/store/report/shift/finish`, params),
		batchRemoveShift: params =>
			service.delete(`/back/store/report/shift/batchRemove`, { params }),
		recalculateShiftDetail: params =>
			service.post(`/back/store/report/shift/recalculate`, params),
		getShiftDetail: params =>
			service.post(`/back/store/report/shift/detail`, params),
		getShiftDetailByDate: params =>
			service.post(`/back/store/report/shift/detailByDate`, params),
		printShiftDetail: params =>
			service.post(`/back/store/report/shift/print`, params),
	},
	// 店家設定
	setting: {
		getStoreVersionInfo: () => service.get(`/back/store/getVersionInfo`),
		getStoreAccountInfo: params =>
			service.get(`/back/store/getAccountInfo`, { params }),
	},
}
